var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiveTracking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, "\n        {' '}\n        ", /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1028.4)"
  }, "\n          {' '}\n          ", /*#__PURE__*/React.createElement("path", {
    d: "m8 1030.4 8 1v19l-8-1z",
    fill: "#ecf0f1"
  }), "{' '}\n          ", /*#__PURE__*/React.createElement("path", {
    d: "m2 1031.4 6-1v19l-6 1z",
    fill: "#bdc3c7"
  }), "{' '}\n          ", /*#__PURE__*/React.createElement("path", {
    d: "m16 1031.4 6-1v19l-6 1z",
    fill: "#bdc3c7"
  }), "{' '}\n          ", /*#__PURE__*/React.createElement("path", {
    d: "m3 1032.4 5-1v17l-5 1z",
    fill: "#27ae60"
  }), "{' '}\n          ", /*#__PURE__*/React.createElement("path", {
    d: "m8 1031.4 8 1v17l-8-1z",
    fill: "#2ecc71"
  }), "{' '}\n          ", /*#__PURE__*/React.createElement("path", {
    d: "m13 1c-1.657 0-3 1.3432-3 3s1.343 3 3 3 3-1.3432 3-3-1.343-3-3-3zm0 2c0.552 0 1 0.4477 1 1s-0.448 1-1 1-1-0.4477-1-1 0.448-1 1-1z",
    transform: "translate(0 1028.4)",
    fill: "#c0392b"
  }), "{' '}\n          ", /*#__PURE__*/React.createElement("path", {
    d: "m21 1048.4-5 1v-17l5-1z",
    fill: "#27ae60"
  }), "{' '}\n          ", /*#__PURE__*/React.createElement("path", {
    d: "m5.6875 1031.8-2.3125 0.5 4.625 4.9v-2.9l-2.3125-2.5z",
    fill: "#f39c12"
  }), "{' '}\n          ", /*#__PURE__*/React.createElement("path", {
    d: "m21 1046.4-5 1v-6l5-3z",
    fill: "#f39c12"
  }), "{' '}\n          ", /*#__PURE__*/React.createElement("path", {
    d: "m21 1048.4-5 1v-6l5-3z",
    fill: "#2980b9"
  }), "{' '}\n          ", /*#__PURE__*/React.createElement("path", {
    d: "m8 1042.4 8-1v6l-8-1z",
    fill: "#f1c40f"
  }), "{' '}\n          ", /*#__PURE__*/React.createElement("path", {
    d: "m8 1044.4 8-1v6l-8-1z",
    fill: "#3498db"
  }), "{' '}\n          ", /*#__PURE__*/React.createElement("path", {
    d: "m3 1045.4 5-3v4l-5 1z",
    fill: "#f39c12"
  }), "{' '}\n          ", /*#__PURE__*/React.createElement("path", {
    d: "m3 1047.4 5-3v4l-5 1z",
    fill: "#2980b9"
  }), "{' '}\n          ", /*#__PURE__*/React.createElement("path", {
    d: "m8 8.8008v-2.8985l4 8.6597h-1.469z",
    transform: "translate(0 1028.4)",
    fill: "#f1c40f"
  }), "{' '}\n          ", /*#__PURE__*/React.createElement("path", {
    d: "m13 1028.4c-2.209 0-4 1.8-4 4 0 0.7 0.1908 1.3 0.5156 1.9 0.0539 0.1 0.1105 0.2 0.1719 0.3l3.3125 5.8 3.312-5.8c0.051-0.1 0.095-0.2 0.141-0.2l0.031-0.1c0.325-0.6 0.516-1.2 0.516-1.9 0-2.2-1.791-4-4-4zm0 2c1.105 0 2 0.9 2 2s-0.895 2-2 2-2-0.9-2-2 0.895-2 2-2z",
    fill: "#e74c3c"
  }), "{' '}\n        "), "{' '}\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveTracking);
export default __webpack_public_path__ + "static/media/live-tracking.285cb7d024a2560b72275d31dadab7fd.svg";
export { ForwardRef as ReactComponent };